export const IsLiteFeatureEnabled = false;

export const SubscriptionPlanNames = {
  Enterprise: 'ENTERPRISE',
  Free: 'FREE',
  CUSTOM: 'CUSTOM'
};

export const DEFAULT_CURRENCY_CODE = 'INR';

// Hidden branches are excluded from the branch list unless this is passed
export const INCLUDE_HIDDEN_BRANCHES_PARAM = 'include_hidden=true';
export const DEFAULT_CURRENCY_SYMBOL = '₹';

export const INPUT_BASE_CLASSNAME =
  '!bg-theme border-cofeeNeutralInactive border disabled:border-grey30 disabled:bg-grey10';

export const INPUT_FOCUS_CLASSNAME =
  'focus:outline-none focus:border-primary focus-within:border-primary focus:shadow-inputShadow';
